import { PageLayout } from "@/components/layout";
import { LoadingSpinner } from "./LoadingSpinner";

type TDashboardSkeletonProps = {
  title?: string;
};

/**
 * Skeleton/loading state for dashboard routes.
 * Shows a minimal loading UI while the dashboard content loads.
 */
export function DashboardSkeleton({ title = "Loading..." }: TDashboardSkeletonProps) {
  return (
    <PageLayout>
      <div className="flex min-h-[200px] flex-1 items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <LoadingSpinner size="lg" />
          <p className="text-sm text-muted-foreground">{title}</p>
        </div>
      </div>
    </PageLayout>
  );
}
